import Img from '@/components/common/Img';
import LOGO_BLACK from '@/assets/images/logo/weee-light.svg';
import ChangeLangue from '@/components/common/ChangeLanguage';
import useClickActionT2 from '@/tracks/useClickActionT2';
import { Back } from '@/components/common/HeaderNew';

type InviteeHeaderProps = {
  className?: string;
  showBack?: boolean;
  onShowBack?: () => void;
};

const InviteeHeader = ({ showBack, onShowBack, className }: InviteeHeaderProps) => {
  const { buttonClickView } = useClickActionT2();

  return (
    <div className="box-border w-full h-12 flex items-center justify-between px-5 bg-surface-100-bg">
      <div className="w-10 h-5">{showBack && <Back onClick={onShowBack} />}</div>
      <div className="flex-1 flex justify-center items-center">
        <Img
          className="h-[25px] self-center cursor-pointer"
          src={LOGO_BLACK}
          alt="logo"
          onClick={() => {
            buttonClickView({
              co: {
                target_nm: 'weee_logo',
                target_pos: 0
              },
              ctx: {
                step: showBack ? 2 : 1
              }
            });
            window.location.href = '/';
          }}
        />
      </div>
      <ChangeLangue
        className="py-0"
        showLabel={false}
        onBeforeSendTrack={params => {
          params.ctx = {
            step: showBack ? 2 : 1
          };
          return params;
        }}
      />
    </div>
  );
};

export default InviteeHeader;
